import { forwardRef } from 'react';
import { StyledButton } from './button.styled';
import ButtonArrow from '@assets/icons/ButtonArrow';
import { useACF } from '@context/ACFContext';

interface ButtonProps {
	primary: boolean;
	children: React.ReactNode;
	className?: string;
	onClick?: () => void;
	href?: string;
	target?: '_blank' | '_self' | '_parent' | '_top';
	rel?: string;
}

export const Button = forwardRef<any, ButtonProps>(
	(
		{ primary = true, children, className, onClick, href, target = '_self', rel = 'noopener noreferrer', ...props },
		ref
	) => {
		const { postTemplate } = useACF();
		const globalComponents = postTemplate?.review_page_v4_global_components;

		if (!globalComponents) return null;

		const {
			button_background_color,
			button_hover_background,
			button_text_color,
			button_background_color_secondary,
			button_hover_background_secondary,
			button_text_color_secondary,
		} = globalComponents;

		const background = primary ? button_background_color : button_background_color_secondary;
		const hoverBackground = primary ? button_hover_background : button_hover_background_secondary;
		const textColor = primary ? button_text_color : button_text_color_secondary;

		const content = (
			<>
				{children}
				<ButtonArrow color={textColor || 'white'} />
			</>
		);

		if (href) {
			return (
				<StyledButton
					as="a"
					href={href}
					target={target}
					rel={rel}
					ref={ref}
					className={className}
					$buttonHoverBackground={hoverBackground}
					$buttonBackground={background}
					$buttonTextColor={textColor}
					{...props}
				>
					{content}
				</StyledButton>
			);
		}

		return (
			<StyledButton
				ref={ref}
				onClick={onClick}
				className={className}
				$buttonHoverBackground={hoverBackground}
				$buttonBackground={background}
				$buttonTextColor={textColor}
				{...props}
			>
				{content}
			</StyledButton>
		);
	}
);

Button.displayName = 'Button';
